export function compareAntTable(a, b) {
	return a === b ? 0 : a < b ? -1 : 1
}

export function getObjectById(array, object_id) {
	let lookup = {}
	for (let i = 0, len = array.length; i < len; i++) {
		lookup[array[i].id] = array[i]
	}

	return lookup[object_id]
}

export function getObjectByKey(array, object_id, key) {
	let lookup = {}
	for (let i = 0, len = array.length; i < len; i++) {
		lookup[array[i][key]] = array[i]
	}

	return lookup[object_id]
}

export function compareDateAntTable(a, b) {
    return a === b ? 0 : a < b ? -1 : 1
}